import React, { useContext } from 'react';
import ArrowDropDownIcon from '@mui/icons-material//ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material//ArrowDropUp';
import { ExtendedFabButton } from 'components/Buttons';
import { LayoutContext } from 'context';
import { AddCompButtonProps } from './AddCompButton.props';

const AddCompButton = ({ openDialog, addComp }: AddCompButtonProps) => {
  const { viewOnlyUser } = useContext(LayoutContext);
  return (
    <ExtendedFabButton
      id="add-comp-btn"
      label="Add Comp Group"
      customIcon={openDialog ? ArrowDropUpIcon : ArrowDropDownIcon}
      onClick={addComp}
      disabled={viewOnlyUser}
      sx={{
        '& span': {
          display: 'inherit',
        },
      }}
    />
  );
};

export default AddCompButton;
